import { UpFloor, DownFloor } from "./Floor"
export default function Footer({
  stake,
  handleStake,
  sendSettings,
  handleAbove,
  sendBet,
  audio,
  gameInfo,
  handleNotification,
  speed,
  colors,
  betSent,
}: any) {
  return (
    <footer>
      <UpFloor
        stake={stake}
        handleStake={handleStake}
        handleAbove={handleAbove}
        handleNotification={handleNotification}
        gameInfo={gameInfo}
        colors={colors}
        // audio={audio}
      />
      <DownFloor
        stake={stake}
        sendSettings={sendSettings}
        sendBet={sendBet}
        handleAbove={handleAbove}
        handleNotification={handleNotification}
        audio={audio}
        speed={speed}
        colors={colors}
        betSent={betSent}
      />
    </footer>
  )
}
